import { Box, Stack, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { getLeaderboards } from "../api/leaderboard";
import { useGlobal } from "../context/GlobalProvider";

async function GetLeaderboard() {
  try {
    // Fetch all matches if no filter is set
    const data = await getLeaderboards();
    if (!data?.body) throw new Error("Invalid API response");
    return data;
  } catch (error) {
    console.error("Error fetching users:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export default function Leaderboard({ user, signOut }) {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const { setCurrentTab } = useGlobal();

  useEffect(() => {
    setCurrentTab("leaderboard");
    const fetchData = async () => {
      const result = await GetLeaderboard(user?.user_type, user?.team_number);
      try {
        const parsedData = JSON.parse(result?.body);
        console.log(parsedData);
        setLeaderboardData(
          Array.isArray(parsedData?.data) ? parsedData.data : []
        );
      } catch (error) {
        console.error("Error parsing user data:", error);
        setLeaderboardData([]);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Stack direction="column" spacing={2} sx={{ width: "75%" }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ alignSelf: "center" }}
          >
            Leaderboard
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: "center" }}
          >
            The leaderboard showcases the top contributors based on their
            participation in matches and pit scouting. Users earn points by
            submitting match data and scouting reports, with medals awarded to
            the top three contributors. 🏆
          </Typography>
        </Stack>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <TableContainer
          component={Paper}
          sx={{ width: { xs: "100%", md: "75%" } }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "33%" }} align="left">
                  Name
                </TableCell>
                <TableCell sx={{ width: "33%" }} align="center">
                  Team Number
                </TableCell>
                <TableCell sx={{ width: "33%" }} align="right">
                  Score
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaderboardData.map((row, index) => {
                // Assign medals to first, second, and third place
                let medal = "";
                if (index === 0) medal = " 🥇";
                else if (index === 1) medal = " 🥈";
                else if (index === 2) medal = " 🥉";

                return (
                  <TableRow
                    key={row.karma_id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left" component="th" scope="row">
                      {row.first_name} {row.last_name} {medal}
                    </TableCell>
                    <TableCell align="center">{row.team_number}</TableCell>
                    <TableCell align="right">{row.count}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
